module.exports = {
  width: 202,
  height: 202,
  bytes: 9604,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + undefined;
};